module.exports = __webpack_public_path__ + "img/FailureTurtle1.fbac844c.gif";